export enum OrchestratorInstanceKind {
  API = 'API',
  EHR = 'EHR',
}
